export const PERMISSIONS = {
  ORGANIZATIONS_VIEW: 'organizations.view',
  ORGANIZATIONS_UPDATE: 'organizations.update',
  ORGANIZATIONS_MEMBERS_MANAGE: 'organizations.members.manage',
  FUNDRAISERS_MANAGE: 'fundraisers.manage',
  FUNDRAISER_PAGES_MANAGE: 'fundraiser-pages.manage',
  DONATIONS_VIEW: 'donations.view',
  DONATIONS_EXPORT: 'donations.export',
  PAYMENT_SERVICES_MANAGE: 'payment-services.manage',
  WEBCONNEX_MANAGE: 'webconnex.manage',
  REPORTS_VIEW: 'reports.view',
  TAX_RECEIPTS_SEND: 'tax-receipts.send',
}
